(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const safeDefine = (name, ctor) => {
    try {
      if (!customElements.get(name)) customElements.define(name, ctor);
    } catch (e) {}
  };

  class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.isMobileMq = window.matchMedia('(max-width: 989px)');

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.preventHide = false;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.onScrollHandler = this.onScroll.bind(this);
    this.onMqChange = this.onMqChange.bind(this);

    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    this.setHeaderHeight();
    this.createObserver();

    this.isMobileMq.addEventListener('change', this.onMqChange);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    if (this.isMobileMq.matches) {
      this.forceMobileStickyState();
    } else if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);

    if (this.isMobileMq) {
      this.isMobileMq.removeEventListener('change', this.onMqChange);
    }
  }

  onMqChange() {
    this.setHeaderHeight();

    if (this.isMobileMq.matches) {
      this.forceMobileStickyState();
    } else if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    } else {
      this.reset();
    }
  }

  forceMobileStickyState() {
    if (!this.header) return;

    this.header.classList.remove(
      'shopify-section-header-sticky',
      'shopify-section-header-hidden',
      'animate',
      'scrolled-past-header'
    );
  }

  setHeaderHeight() {
    if (!this.header) return;
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  createObserver() {
    if (!this.header) return;

    const observer = new IntersectionObserver((entries, obs) => {
      if (entries && entries[0]) {
        this.headerBounds = entries[0].intersectionRect || {};
      }
      obs.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    if (!this.header) return;

    if (this.isMobileMq.matches) {
      this.forceMobileStickyState();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (document.body.classList.contains('ct-search-overlay-open')) return;

    const thresholdBottom =
      typeof this.headerBounds.bottom === 'number' ? this.headerBounds.bottom : this.header.offsetHeight;
    const thresholdTop =
      typeof this.headerBounds.top === 'number' ? this.headerBounds.top : 0;

    const goingDown = scrollTop > this.currentScrollTop;

    if (goingDown && scrollTop > thresholdBottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) {
        requestAnimationFrame(() => this.hide());
      }
    } else if (!goingDown && scrollTop > thresholdBottom) {
      this.header.classList.add('scrolled-past-header');

      if (!this.preventReveal) {
        requestAnimationFrame(() => this.reveal());
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = window.setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(() => this.hide());
      }
    } else if (scrollTop <= thresholdTop) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(() => this.reset());
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.header || this.headerIsAlwaysSticky || this.isMobileMq.matches) return;

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (!this.header || this.headerIsAlwaysSticky || this.isMobileMq.matches) return;

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (!this.header || this.headerIsAlwaysSticky || this.isMobileMq.matches) return;

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    if (!this.header) return;

    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => {
      if (typeof disclosure.close === 'function') disclosure.close();
    });
  }

  closeSearchModal() {
    if (!this.header) return;

    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal && typeof this.searchModal.close === 'function') {
      this.searchModal.close(false);
    }
  }
}

  safeDefine('sticky-header', StickyHeader);

class DesktopHeaderController {
  constructor() {
    this.mq = window.matchMedia('(min-width: 990px)');
    this.whiteBar = document.getElementById('CtDesktopRevealBar');
    this.bottomBar = document.getElementById('CtBottomBar');
    this.whiteHidden = false;
    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.raf = null;

    const body = document.body;
    const path = window.location.pathname || '';
    const shopifyPageType = body ? body.getAttribute('data-page-type') : '';
    const bodyClassProduct = body && body.classList.contains('template-product');
    const pathProduct = path.indexOf('/products/') !== -1;
    const explicitProductType = shopifyPageType === 'product';

    this.isProductPage = bodyClassProduct || pathProduct || explicitProductType;

    if (!this.whiteBar || !this.bottomBar) return;

    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);

    this.mq.addEventListener('change', this.onResize);
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.onResize();

    window.addEventListener('load', () => {
      if (!this.mq.matches) return;
      this.recalcAll();
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!this.mq.matches) return;
        this.recalcAll();
      });
    }
  }

  getAnnouncementOffset() {
    const ann =
      document.querySelector('#shopify-section-announcement-bar') ||
      document.querySelector('.announcement-bar') ||
      document.querySelector('[data-announcement-bar]');

    if (!ann) return 0;

    const rect = ann.getBoundingClientRect();
    const h = rect.height || 0;
    const visible = Math.max(0, Math.min(h, rect.bottom));
    return visible < 1 ? 0 : visible;
  }

  setVar(name, valuePx) {
    document.documentElement.style.setProperty(name, `${Math.round(valuePx)}px`);
  }

  recalcAll() {
    const annOffset = Math.round(this.getAnnouncementOffset());
    const whiteH = Math.round(this.whiteBar.offsetHeight || this.whiteBar.getBoundingClientRect().height || 0);
    const bottomH = Math.round(this.bottomBar.offsetHeight || this.bottomBar.getBoundingClientRect().height || 0);

    this.setVar('--ct-announcement-offset', annOffset);
    this.setVar('--ct-revealbar-height', whiteH);
    this.setVar('--ct-bottom-height', bottomH);

    const overlap = 3;
    const effectiveWhiteHidden = this.isProductPage ? false : this.whiteHidden;
    const visibleWhiteH = effectiveWhiteHidden ? 0 : whiteH;

    const revealTop = effectiveWhiteHidden ? annOffset - whiteH : annOffset;
    const bottomTop = annOffset + visibleWhiteH - overlap;

    const mainOffset = annOffset + bottomH + visibleWhiteH;

    const facetsTop = annOffset + visibleWhiteH + bottomH + 16;
    const facetsMaxHeight = window.innerHeight - facetsTop - 32;

    this.setVar('--ct-revealbar-top', revealTop);
    this.setVar('--ct-bottom-top', bottomTop);
    this.setVar('--ct-main-offset', mainOffset);
    this.setVar('--ct-facets-top', facetsTop);
    this.setVar('--ct-facets-max-height', Math.max(120, facetsMaxHeight));
  }

  setWhiteHidden(hidden) {
    if (this.isProductPage) {
      hidden = false;
    }

    if (this.whiteHidden === hidden) return;

    this.whiteHidden = hidden;
    document.body.classList.toggle('ct-white-hidden', hidden);
    this.recalcAll();
  }

  onResize() {
    if (!this.mq.matches) return;
    if (document.body.classList.contains('ct-search-overlay-open')) return;

    this.whiteHidden = false;
    document.body.classList.remove('ct-white-hidden');
    this.recalcAll();
    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  onScroll() {
    if (!this.mq.matches) return;
    if (document.body.classList.contains('ct-search-overlay-open')) return;
    if (this.raf) return;

    this.raf = requestAnimationFrame(() => {
      this.raf = null;

      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;

      if (this.isProductPage) {
        this.setWhiteHidden(false);
        this.lastScrollTop = scrollTop;
        return;
      }

      const maxScroll = Math.max(0, doc.scrollHeight - window.innerHeight);
      const delta = scrollTop - this.lastScrollTop;

      const atTop = scrollTop <= 0;
      const atBottom = maxScroll > 0 && scrollTop >= maxScroll - 2;

      if (Math.abs(delta) < 2) {
        this.lastScrollTop = scrollTop;
        return;
      }

      if (atTop) {
        this.setWhiteHidden(false);
        this.lastScrollTop = scrollTop;
        return;
      }

      if (atBottom) {
        this.setWhiteHidden(true);
        this.lastScrollTop = scrollTop;
        return;
      }

      this.setWhiteHidden(delta > 0);
      this.lastScrollTop = scrollTop;
    });
  }
}

  class DesktopPredictiveOverlay {
    constructor() {
      this.mq = window.matchMedia('(min-width: 990px)');
      this.overlay = document.getElementById('CtSearchOverlay');
      this.overlayPanel = this.overlay ? this.overlay.querySelector('.ct-search-overlay__panel') : null;

      this.searchRoot = document.querySelector('.ct-header-desktop .ct-search');
      this.predictiveRoot = this.searchRoot ? this.searchRoot.querySelector('.predictive-search') : null;
      this.predictiveElement = this.searchRoot ? this.searchRoot.querySelector('predictive-search') : null;
      this.form = this.searchRoot ? this.searchRoot.querySelector('form.search--header') : null;
      this.input = this.searchRoot ? this.searchRoot.querySelector('input[type="search"]') : null;
      this.resetButton = this.searchRoot ? this.searchRoot.querySelector('button[type="reset"].reset__button') : null;

      this.pageWidthReference =
        document.querySelector('#CtDesktopRevealBar > .page-width') ||
        document.querySelector('.ct-desktop-revealbar .page-width');

      this.bestSellerProducts = this.readBestSellerProducts();

      this.domObserver = null;
      this.suppressOpenUntil = 0;
      this.isClosing = false;

      this.state = {
        view: 'closed',
        query: '',
        lastRenderedKey: ''
      };

      if (
        !this.overlay ||
        !this.overlayPanel ||
        !this.searchRoot ||
        !this.predictiveRoot ||
        !this.predictiveElement ||
        !this.form ||
        !this.input ||
        !this.pageWidthReference
      ) {
        return;
      }

      this.onMqChange = this.onMqChange.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPredictiveDomChange = this.onPredictiveDomChange.bind(this);

      this.init();
    }

    init() {
      this.bindGlobalEvents();
      this.bindSearchEvents();
      this.bindPredictiveObserver();
    }

    isDesktop() {
      return this.mq.matches;
    }

    isOpen() {
      return document.body.classList.contains('ct-search-overlay-open');
    }

    shouldSuppressOpen() {
      return this.isClosing || Date.now() < this.suppressOpenUntil;
    }

    setVar(name, value) {
      document.documentElement.style.setProperty(name, value);
    }

    readBestSellerProducts() {
      const script = document.getElementById('CtBestSellerProductsData');
      if (!script) return [];

      try {
        const parsed = JSON.parse(script.textContent || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    getResultsSource() {
      return (
        this.predictiveRoot.querySelector('[data-predictive-search-results]') ||
        this.predictiveRoot.querySelector('#predictive-search-results') ||
        null
      );
    }

    getPredictiveProductsHeading() {
      const scoped =
        this.predictiveRoot.querySelector('#predictive-search-products') ||
        document.getElementById('predictive-search-products');

      const text = scoped ? scoped.textContent.trim() : '';
      return text || 'Prodotti';
    }

    positionOverlay() {
      if (!this.isDesktop()) return;

      const inputRect = this.input.getBoundingClientRect();
      const refRect = this.pageWidthReference.getBoundingClientRect();

      this.setVar('--ct-ps-top', `${Math.round(inputRect.bottom + 10)}px`);
      this.setVar('--ct-ps-content-width', `${Math.round(refRect.width)}px`);
      this.setVar('--ct-search-backdrop-top', `${Math.round(inputRect.bottom + 18)}px`);
    }

    closeDesktopMenus() {
      document.querySelectorAll('#CtBottomBar details[open], .ct-header-desktop details[open]').forEach((detailsEl) => {
        detailsEl.removeAttribute('open');
      });

      document.querySelectorAll('#CtBottomBar header-menu, .ct-header-desktop header-menu').forEach((menuEl) => {
        if (typeof menuEl.close === 'function') {
          try {
            menuEl.close();
          } catch (e) {}
        }
      });

      document.querySelectorAll('#CtBottomBar summary[aria-expanded="true"], .ct-header-desktop summary[aria-expanded="true"]').forEach((summary) => {
        summary.setAttribute('aria-expanded', 'false');
      });
    }

    ensureShell() {
      let shell = this.overlayPanel.querySelector(':scope > .ct-ps-shell');

      if (!shell) {
        shell = document.createElement('div');
        shell.className = 'ct-ps-shell';
        shell.innerHTML = `
          <div class="ct-ps-head">
            <button type="button" class="ct-ps-close" aria-label="Chiudi ricerca">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke-width="2" stroke-linecap="round"></path>
              </svg>
            </button>
          </div>
          <div class="ct-ps-inner">
            <div class="ct-ps-panel"></div>
          </div>
        `;

        this.overlayPanel.innerHTML = '';
        this.overlayPanel.appendChild(shell);

        const closeBtn = shell.querySelector('.ct-ps-close');
        if (closeBtn) {
          const closeHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            this.closeOverlay({ clearInput: true });
          };

          closeBtn.addEventListener('pointerdown', closeHandler, true);
          closeBtn.addEventListener('click', closeHandler, true);
        }
      }

      return shell;
    }

    getResultsPanel() {
      const shell = this.ensureShell();
      return shell ? shell.querySelector('.ct-ps-panel') : null;
    }

    destroyShell() {
      const shell = this.overlayPanel.querySelector(':scope > .ct-ps-shell');
      if (shell) shell.remove();
    }

    clearPanel() {
      const panel = this.getResultsPanel();
      if (!panel) return;
      panel.innerHTML = '';
    }

    closeDawnPredictive(clearInput = true) {
      if (this.predictiveElement && typeof this.predictiveElement.close === 'function') {
        try {
          this.predictiveElement.close(clearInput);
        } catch (e) {
          try {
            this.predictiveElement.close();
          } catch (err) {}
        }
      }

      this.predictiveRoot.classList.remove('predictive-search--loading');
      this.predictiveRoot.removeAttribute('open');

      if (clearInput) {
        const source = this.getResultsSource();
        if (source) source.innerHTML = '';

        const status = this.predictiveRoot.querySelector('[data-predictive-search-status]');
        if (status) status.textContent = '';
      }
    }

    escapeHtml(value) {
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }

    buildEmptyLeftColumn() {
      const leftCol = document.createElement('div');
      leftCol.className = 'ct-ps-left ct-ps-left-empty';
      leftCol.innerHTML = '&nbsp;';
      return leftCol;
    }

    buildSuggestionsColumn(items) {
      const leftCol = document.createElement('div');
      leftCol.className = 'ct-ps-left';

      const inner = document.createElement('div');
      inner.className = 'ct-ps-left-inner';

      const title = document.createElement('div');
      title.className = 'ct-ps-left-title';
      title.textContent = 'Suggerimenti';

      const list = document.createElement('ul');
      list.className = 'ct-ps-suggestions-list';

      items.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'ct-ps-suggestion-item';

        if (item.type === 'link' && item.href) {
          const a = document.createElement('a');
          a.className = 'ct-ps-suggestion-link';
          a.href = item.href;
          a.textContent = item.label;
          li.appendChild(a);
        } else {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ct-ps-suggestion-button';
          button.textContent = item.label;
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.input.value = item.label;
            this.input.focus();
            this.input.dispatchEvent(new Event('input', { bubbles: true }));
          });
          li.appendChild(button);
        }

        list.appendChild(li);
      });

      inner.appendChild(title);
      inner.appendChild(list);
      leftCol.appendChild(inner);

      return leftCol;
    }

    buildProductsColumn(products, headingText) {
      const rightCol = document.createElement('div');
      rightCol.className = 'ct-ps-right';

      const wrap = document.createElement('div');
      wrap.className = 'ct-ps-right-inner';

      const top = document.createElement('div');
      top.className = 'ct-ps-products-top';

      const nav = document.createElement('div');
      nav.className = 'ct-ps-nav';
      nav.innerHTML = `
        <button type="button" class="ct-ps-prev" aria-label="Precedente">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 6l-6 6 6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        <button type="button" class="ct-ps-next" aria-label="Successivo">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 6l6 6-6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      `;

      const heading = document.createElement('div');
      heading.className = 'ct-ps-products-heading';
      heading.textContent = headingText;

      top.appendChild(nav);
      top.appendChild(heading);
      wrap.appendChild(top);

      if (!products.length) {
        const message = document.createElement('div');
        message.className = 'ct-ps-state-message';
        message.textContent = 'Nessun prodotto trovato.';
        wrap.appendChild(message);
        rightCol.appendChild(wrap);
        return rightCol;
      }

      const track = document.createElement('div');
      track.className = 'ct-ps-products-track';

      products.forEach((product) => {
        const card = document.createElement('div');
        card.className = 'ct-ps-product-card';

        if (product.node) {
          card.appendChild(product.node);
        } else {
          card.innerHTML = `
            <a href="${product.url || '#'}">
              ${product.image ? `<img src="${product.image}" alt="${this.escapeHtml(product.title || '')}">` : ''}
              <div class="predictive-search__item-content">
                ${product.vendor ? `<span class="predictive-search__item-vendor">${this.escapeHtml(product.vendor)}</span>` : ''}
                <span class="predictive-search__item-heading">${this.escapeHtml(product.title || '')}</span>
                <div class="price">
                  ${product.compare_at_price ? `<s>${this.escapeHtml(product.compare_at_price)}</s>` : ''}
                  ${product.price ? `<span class="price-item price-item--sale">${this.escapeHtml(product.price)}</span>` : ''}
                </div>
              </div>
            </a>
          `;
        }

        track.appendChild(card);
      });

      wrap.appendChild(track);
      rightCol.appendChild(wrap);

      const prevBtn = nav.querySelector('.ct-ps-prev');
      const nextBtn = nav.querySelector('.ct-ps-next');

      const scrollAmount = () => {
        const firstCard = track.querySelector('.ct-ps-product-card');
        if (!firstCard) return Math.max(260, Math.round(track.clientWidth * 0.7));
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap || 0) || 0;
        return Math.round(firstCard.getBoundingClientRect().width + gap);
      };

      const updateNavState = () => {
        const maxScrollLeft = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= maxScrollLeft - 4;
      };

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNavState, { passive: true });
      requestAnimationFrame(updateNavState);

      return rightCol;
    }

    buildLoadingColumn(headingText) {
      const rightCol = document.createElement('div');
      rightCol.className = 'ct-ps-right';

      const wrap = document.createElement('div');
      wrap.className = 'ct-ps-right-inner';

      const top = document.createElement('div');
      top.className = 'ct-ps-products-top';

      const nav = document.createElement('div');
      nav.className = 'ct-ps-nav';
      nav.innerHTML = `
        <button type="button" class="ct-ps-prev" aria-label="Precedente" disabled>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 6l-6 6 6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        <button type="button" class="ct-ps-next" aria-label="Successivo" disabled>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 6l6 6-6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
      `;

      const heading = document.createElement('div');
      heading.className = 'ct-ps-products-heading';
      heading.textContent = headingText;

      const message = document.createElement('div');
      message.className = 'ct-ps-state-message';
      message.textContent = 'Caricamento prodotti...';

      top.appendChild(nav);
      top.appendChild(heading);
      wrap.appendChild(top);
      wrap.appendChild(message);
      rightCol.appendChild(wrap);

      return rightCol;
    }

    extractPredictiveProducts() {
      const source = this.getResultsSource();
      if (!source) return [];

      const productList =
        source.querySelector('#predictive-search-results-products-list') ||
        source.querySelector('[id*="predictive-search-results-products-list"]') ||
        source.querySelector('ul');

      if (!productList) return [];

      return Array.from(productList.querySelectorAll(':scope > li'))
        .map((li) => {
          const link = li.querySelector('a');
          if (!link) return null;

          const clone = link.cloneNode(true);
          const img = clone.querySelector('img');

          if (img) {
            const src = img.getAttribute('src') || '';
            const srcset = img.getAttribute('srcset') || '';

            const upgradedSrc = src
              .replace(/([?&])width=\d+/g, '$1width=700')
              .replace(/width:\d+/g, 'width:700');

            const upgradedSrcset = srcset
              .split(',')
              .map((entry) => {
                const trimmed = entry.trim();
                if (!trimmed) return trimmed;

                return trimmed
                  .replace(/([?&])width=\d+/g, '$1width=700')
                  .replace(/width:\d+/g, 'width:700');
              })
              .join(', ');

            if (upgradedSrc) {
              img.setAttribute('src', upgradedSrc);
            }

            if (upgradedSrcset) {
              img.setAttribute('srcset', upgradedSrcset);
            }

            img.setAttribute('sizes', '250px');
            img.setAttribute('loading', 'eager');
            img.setAttribute('decoding', 'async');
          }

          return {
            node: clone
          };
        })
        .filter(Boolean)
        .slice(0, 12);
    }

    extractSuggestions() {
      const source = this.getResultsSource();
      if (!source) return [];

      const selectors = [
        '#predictive-search-results-queries-list',
        '[id*="predictive-search-results-queries-list"]',
        '#predictive-search-results-collections-list',
        '[id*="predictive-search-results-collections-list"]',
        '#predictive-search-results-pages-list',
        '[id*="predictive-search-results-pages-list"]',
        '#predictive-search-results-articles-list',
        '[id*="predictive-search-results-articles-list"]'
      ];

      const rawNodes = [];

      selectors.forEach((selector) => {
        source.querySelectorAll(selector).forEach((list) => {
          rawNodes.push(...list.querySelectorAll(':scope > li a, :scope > li button'));
        });
      });

      const seen = new Set();
      const items = [];

      rawNodes.forEach((node) => {
        const label = (node.textContent || '').trim().replace(/\s+/g, ' ');
        if (!label) return;

        const href = node.tagName.toLowerCase() === 'a' ? node.getAttribute('href') || '' : '';
        const type = href ? 'link' : 'button';
        const key = `${type}|${href}|${label}`;

        if (seen.has(key)) return;
        seen.add(key);

        items.push({
          type,
          href,
          label
        });
      });

      return items.slice(0, 8);
    }

    getPredictiveState() {
      const source = this.getResultsSource();
      const term = (this.input.value || '').trim();

      if (!term) {
        return {
          status: 'empty-input',
          heading: 'Prodotti più venduti',
          products: [],
          suggestions: []
        };
      }

      if (this.predictiveRoot.classList.contains('predictive-search--loading')) {
        return {
          status: 'loading',
          heading: 'Prodotti',
          products: [],
          suggestions: []
        };
      }

      if (!source) {
        return {
          status: 'loading',
          heading: 'Prodotti',
          products: [],
          suggestions: []
        };
      }

      const html = (source.innerHTML || '').trim();
      const products = this.extractPredictiveProducts();
      const suggestions = this.extractSuggestions();
      const heading = this.getPredictiveProductsHeading();

      if (products.length > 0 || suggestions.length > 0) {
        return {
          status: 'ready',
          heading,
          products,
          suggestions
        };
      }

      if (html === '') {
        return {
          status: 'loading',
          heading: 'Prodotti',
          products: [],
          suggestions: []
        };
      }

      return {
        status: 'empty',
        heading,
        products: [],
        suggestions: []
      };
    }

    makeRenderKey(view, term, heading, products, suggestions = []) {
      const productIds = products
        .map((product) => {
          if (product.url) return product.url;
          if (product.node) {
            const href = product.node.getAttribute('href') || '';
            const text = (product.node.textContent || '').trim();
            return `${href}|${text}`;
          }
          return '';
        })
        .join('||');

      const suggestionIds = suggestions
        .map((item) => `${item.type}|${item.href || ''}|${item.label || ''}`)
        .join('||');

      return `${view}::${term}::${heading}::${productIds}::${suggestionIds}`;
    }

    renderEmptyState(force = false) {
      const renderKey = this.makeRenderKey('empty', '', 'Prodotti più venduti', this.bestSellerProducts, []);

      if (!force && this.state.lastRenderedKey === renderKey) return;

      this.state.view = 'empty';
      this.clearPanel();

      const panel = this.getResultsPanel();
      if (!panel) return;

      panel.className = 'ct-ps-panel ct-ps-panel--products-only';
      panel.appendChild(this.buildProductsColumn(this.bestSellerProducts, 'Prodotti più venduti'));

      this.state.lastRenderedKey = renderKey;
    }

    renderLoadingState(force = false) {
      const term = (this.input.value || '').trim();
      const renderKey = `loading::${term}`;

      if (!force && this.state.lastRenderedKey === renderKey) return;

      this.state.view = 'loading';
      this.clearPanel();

      const panel = this.getResultsPanel();
      if (!panel) return;

      panel.className = 'ct-ps-panel';
      panel.appendChild(this.buildEmptyLeftColumn());
      panel.appendChild(this.buildLoadingColumn('Prodotti'));

      this.state.lastRenderedKey = renderKey;
    }

    renderSearchResults(force = false) {
      const term = (this.input.value || '').trim();
      const predictiveState = this.getPredictiveState();

      if (predictiveState.status === 'empty-input') {
        this.renderEmptyState(force);
        return;
      }

      if (predictiveState.status === 'loading') {
        this.renderLoadingState(force);
        return;
      }

      const renderKey = this.makeRenderKey(
        predictiveState.status === 'ready' ? 'results' : 'no-results',
        term,
        predictiveState.heading,
        predictiveState.products,
        predictiveState.suggestions
      );

      if (!force && this.state.lastRenderedKey === renderKey) return;

      this.state.view = predictiveState.status === 'ready' ? 'results' : 'no-results';
      this.clearPanel();

      const panel = this.getResultsPanel();
      if (!panel) return;

      panel.className = 'ct-ps-panel';

      if (predictiveState.suggestions.length) {
        panel.appendChild(this.buildSuggestionsColumn(predictiveState.suggestions));
      } else {
        panel.appendChild(this.buildEmptyLeftColumn());
      }

      panel.appendChild(this.buildProductsColumn(predictiveState.products, predictiveState.heading));

      this.state.lastRenderedKey = renderKey;
    }

    openOverlay() {
      if (!this.isDesktop()) return;
      if (this.isOpen()) return;
      if (this.shouldSuppressOpen()) return;

      this.closeDesktopMenus();
      this.positionOverlay();

      document.body.classList.add('ct-search-overlay-open');
      this.overlay.hidden = false;
      this.overlay.setAttribute('aria-hidden', 'false');

      this.ensureShell();

      const term = (this.input.value || '').trim();
      this.state.query = term;
      this.state.lastRenderedKey = '';

      if (!term) {
        this.renderEmptyState(true);
      } else {
        this.renderLoadingState(true);
      }
    }

    closeOverlay({ clearInput = true } = {}) {
      if (!this.isOpen() || this.isClosing) return;

      this.isClosing = true;
      this.suppressOpenUntil = Date.now() + 250;

      document.body.classList.remove('ct-search-overlay-open');
      this.overlay.hidden = true;
      this.overlay.setAttribute('aria-hidden', 'true');

      if (clearInput && this.input) {
        this.input.value = '';
      }

      if (this.input) this.input.blur();
      this.closeDawnPredictive(clearInput);

      this.state.view = 'closed';
      this.state.query = '';
      this.state.lastRenderedKey = '';

      this.destroyShell();

      window.setTimeout(() => {
        this.isClosing = false;
      }, 260);
    }

    handleInput() {
      const term = (this.input.value || '').trim();
      this.state.query = term;

      if (!this.isOpen()) {
        if (this.shouldSuppressOpen()) return;
        this.openOverlay();
      }

      if (!term) {
        this.renderEmptyState(true);
        return;
      }

      this.renderLoadingState(true);
    }

    onPredictiveDomChange() {
      if (!this.isDesktop()) return;
      if (!this.isOpen()) return;

      const term = (this.input.value || '').trim();

      if (!term) {
        this.renderEmptyState();
        return;
      }

      this.renderSearchResults(true);
    }

    bindSearchEvents() {
      if (this.searchRoot.dataset.ctOverlayBound === '1') return;
      this.searchRoot.dataset.ctOverlayBound = '1';

      this.searchRoot.addEventListener(
        'pointerdown',
        (e) => {
          if (!this.isDesktop()) return;
          if (this.shouldSuppressOpen()) return;

          const clickedInput = e.target.closest('input[type="search"]');
          const clickedSubmit = e.target.closest('button[type="submit"].search__button');

          if (!clickedInput && !clickedSubmit) return;

          if (!this.isOpen()) {
            this.openOverlay();
          }
        },
        true
      );

      this.searchRoot.addEventListener(
        'focusin',
        (e) => {
          if (!this.isDesktop()) return;
          if (this.shouldSuppressOpen()) return;
          if (!e.target.closest('input[type="search"]')) return;

          if (!this.isOpen()) {
            this.openOverlay();
          }
        },
        true
      );

      this.input.addEventListener(
        'input',
        () => {
          if (!this.isDesktop()) return;
          this.handleInput();
        },
        true
      );

      this.input.addEventListener(
        'click',
        () => {
          if (!this.isDesktop()) return;

          if (!this.isOpen() && !this.shouldSuppressOpen()) {
            this.openOverlay();
          }
        },
        true
      );

      const submitButton = this.searchRoot.querySelector('button[type="submit"].search__button');
      if (submitButton) {
        submitButton.addEventListener(
          'pointerdown',
          () => {
            if (!this.isDesktop()) return;

            if (!this.isOpen() && !this.shouldSuppressOpen()) {
              this.openOverlay();
            }
          },
          true
        );
      }

      if (this.resetButton) {
        const resetHandler = (e) => {
          if (!this.isDesktop()) return;
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          this.closeOverlay({ clearInput: true });
        };

        this.resetButton.addEventListener('pointerdown', resetHandler, true);
        this.resetButton.addEventListener('click', resetHandler, true);
      }
    }

    bindPredictiveObserver() {
      if (this.domObserver) return;

      this.domObserver = new MutationObserver(this.onPredictiveDomChange);
      this.domObserver.observe(this.predictiveRoot, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'open']
      });
    }

    onMqChange() {
      if (!this.isDesktop()) {
        this.closeOverlay({ clearInput: true });
        return;
      }

      this.positionOverlay();
    }

    onResize() {
      if (!this.isDesktop()) return;
      if (!this.isOpen()) return;
      this.positionOverlay();
    }

    onScroll() {
      if (!this.isDesktop()) return;
      if (!this.isOpen()) return;
      this.positionOverlay();
    }

    bindGlobalEvents() {
      this.mq.addEventListener('change', this.onMqChange);
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      document.addEventListener('shopify:section:load', () => {
        this.positionOverlay();
      });
    }
  }

  function ctNormaliseMenuLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function ctGetTopLevelMenuTrigger(li) {
    return (
      li.querySelector(':scope > a') ||
      li.querySelector(':scope > details > summary') ||
      li.querySelector(':scope > header-menu > details > summary')
    );
  }

  function ctTagBottomBarMenuItems() {
    const root = document.querySelector('#CtBottomBar .list-menu--inline');
    if (!root) return;

    const items = root.querySelectorAll(':scope > li');

    items.forEach((li) => {
      li.classList.remove('ct-menu-item--marchi', 'ct-menu-item--servizi', 'ct-menu-item--promo');

      const trigger = ctGetTopLevelMenuTrigger(li);
      if (!trigger) return;

      const label = ctNormaliseMenuLabel(trigger.textContent);

      if (label === 'marchi') {
        li.classList.add('ct-menu-item--marchi');
      }

      if (label === 'servizi') {
        li.classList.add('ct-menu-item--servizi');
      }

      if (label === 'promo') {
        li.classList.add('ct-menu-item--promo');
      }
    });
  }

    function ctGetMobileAnnouncementSection() {
    return (
      document.querySelector('#shopify-section-announcement-bar') ||
      document.querySelector('[id*="shopify-section"][id*="announcement-bar"]') ||
      document.querySelector('.announcement-bar-section')
    );
  }

  function ctSetMobileAnnouncementHeight() {
    const isMobile = window.matchMedia('(max-width: 989px)').matches;

    if (!isMobile) {
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    const annSection = ctGetMobileAnnouncementSection();

    if (!annSection) {
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    const rect = annSection.getBoundingClientRect();
    const height = Math.round(rect.height || annSection.offsetHeight || 0);

    document.documentElement.style.setProperty('--ct-mobile-announcement-height', `${height}px`);
  }


class MobilePredictiveEnhancer {
  constructor() {
    this.mq = window.matchMedia('(max-width: 989px)');
    this.bestSellerProducts = this.readBestSellerProducts();
    this.instances = [];
    this.bound = false;

    this.minQueryLength = 1;

    this.onMqChange = this.onMqChange.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);

    this.init();
  }

  init() {
    this.scan();
    this.mq.addEventListener('change', this.onMqChange);

    if (!this.bound) {
      document.addEventListener('click', this.onDocumentClick, true);
      document.addEventListener('shopify:section:load', () => {
        this.scan();
        this.syncMobileUiState();
        this.setAnnouncementHeight();

        window.setTimeout(() => {
          this.setAnnouncementHeight();
        }, 120);
      });

      window.addEventListener(
        'resize',
        () => {
          this.setAnnouncementHeight();
        },
        { passive: true }
      );

      this.syncMobileUiState();
      this.setAnnouncementHeight();

      window.setTimeout(() => {
        this.setAnnouncementHeight();
      }, 120);

      this.bound = true;
    }
  }

  isMobile() {
    return this.mq.matches;
  }

  getAnnouncementBarElement() {
    return (
      document.querySelector('#shopify-section-announcement-bar') ||
      document.querySelector('[id*="shopify-section"][id*="announcement-bar"]') ||
      document.querySelector('.announcement-bar-section')
    );
  }

  setAnnouncementHeight() {
    if (!this.isMobile()) {
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    if (document.body.classList.contains('ct-mobile-search-open')) {
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    const announcementRoot = this.getAnnouncementBarElement();
    if (!announcementRoot) {
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    const bar = announcementRoot.querySelector('.utility-bar') || announcementRoot;
    const height = Math.round(bar.getBoundingClientRect().height || bar.offsetHeight || 0);

    document.documentElement.style.setProperty('--ct-mobile-announcement-height', `${height}px`);
  }

  getOpenInstances() {
    return this.instances.filter((instance) => {
      return instance && instance.details && instance.details.hasAttribute('open');
    });
  }

  isSearchOpen() {
    return this.getOpenInstances().length > 0;
  }

  lockPageScroll() {
    if (!this.isMobile()) return;
    document.body.classList.add('ct-mobile-search-open');
    document.documentElement.classList.add('ct-mobile-search-open');
  }

  unlockPageScroll() {
    document.body.classList.remove('ct-mobile-search-open');
    document.documentElement.classList.remove('ct-mobile-search-open');
  }

  syncMobileUiState() {
    if (!this.isMobile()) {
      this.unlockPageScroll();
      document.body.classList.remove('ct-mobile-announcement-hidden');
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    const searchOpen = this.isSearchOpen();

    if (searchOpen) {
      this.lockPageScroll();
    } else {
      this.unlockPageScroll();
    }

    document.body.classList.remove('ct-mobile-announcement-hidden');
    this.setAnnouncementHeight();
  }

  onMqChange() {
    this.scan();
    this.syncMobileUiState();

    if (!this.isMobile()) {
      this.unlockPageScroll();
      document.body.classList.remove('ct-mobile-search-open');
      document.documentElement.classList.remove('ct-mobile-search-open');
      document.body.classList.remove('ct-mobile-announcement-hidden');
      document.documentElement.style.setProperty('--ct-mobile-announcement-height', '0px');
      return;
    }

    this.setAnnouncementHeight();

    window.setTimeout(() => {
      this.setAnnouncementHeight();
    }, 120);
  }

  onDocumentClick() {
    window.setTimeout(() => {
      this.scan();
      this.syncMobileUiState();
    }, 50);
  }

  readBestSellerProducts() {
    const script = document.getElementById('CtBestSellerProductsData');
    if (!script) return [];

    try {
      const parsed = JSON.parse(script.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  scan() {
    const wrappers = document.querySelectorAll('.ct-header-mobile details-modal.header__search');

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.ctMobileEnhanced === '1') return;
      this.setupWrapper(wrapper);
      wrapper.dataset.ctMobileEnhanced = '1';
    });
  }

  setupWrapper(wrapper) {
    const details = wrapper.querySelector('details');
    const modalContent = wrapper.querySelector('.search-modal__content');
    const form = wrapper.querySelector('form.search.search-modal__form');
    const input = wrapper.querySelector('input[type="search"]');
    const predictiveRoot = wrapper.querySelector('.predictive-search[data-predictive-search]');
    const resetButton = wrapper.querySelector('button[type="reset"].reset__button');

    if (!details || !modalContent || !form || !input || !predictiveRoot) return;

    const rail = this.createRail();

    if (!modalContent.querySelector('.ct-mobile-search-rail')) {
      modalContent.appendChild(rail);
    }

    const instance = {
      wrapper,
      details,
      modalContent,
      form,
      input,
      predictiveRoot,
      resetButton,
      rail,
      observer: null,
      refreshTimer: null,
      lastProductsRenderKey: '',
      lastSuggestionsRenderKey: ''
    };

    const onOpenStateChange = () => {
      const open = details.hasAttribute('open');

      if (!this.isMobile()) {
        this.hideRail(instance);
        this.unlockPageScroll();
        this.setAnnouncementHeight();
        return;
      }

      this.syncMobileUiState();

      if (!open) {
        this.hideRail(instance);
        this.setAnnouncementHeight();
        return;
      }

      window.setTimeout(() => {
        this.syncMobileUiState();
        this.refresh(instance, true);
        this.setAnnouncementHeight();
      }, 80);
    };

    details.addEventListener('toggle', onOpenStateChange);

    input.addEventListener(
      'focus',
      () => {
        if (!this.isMobile()) return;
        if (!details.hasAttribute('open')) return;

        this.syncMobileUiState();
        this.refresh(instance, true);
      },
      true
    );

    input.addEventListener(
      'input',
      () => {
        if (!this.isMobile()) return;
        if (!details.hasAttribute('open')) return;

        this.syncMobileUiState();
        this.scheduleRefresh(instance, 120);
      },
      true
    );

    if (resetButton) {
      const resetHandler = () => {
        if (!this.isMobile()) return;
        if (!details.hasAttribute('open')) return;

        this.scheduleRefresh(instance, 80);
      };

      resetButton.addEventListener('click', resetHandler, true);
      resetButton.addEventListener('pointerdown', resetHandler, true);
    }

    const observer = new MutationObserver(() => {
      if (!this.isMobile()) return;
      if (!details.hasAttribute('open')) return;

      this.syncMobileUiState();
      this.scheduleRefresh(instance, 60);
    });

    observer.observe(predictiveRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });

    instance.observer = observer;
    this.instances.push(instance);
  }

  scheduleRefresh(instance, delay = 80) {
    if (!instance) return;

    if (instance.refreshTimer) {
      window.clearTimeout(instance.refreshTimer);
    }

    instance.refreshTimer = window.setTimeout(() => {
      instance.refreshTimer = null;
      this.refresh(instance, true);
    }, delay);
  }

  createRail() {
    const rail = document.createElement('div');
    rail.className = 'ct-mobile-search-rail';
    rail.hidden = true;
    rail.innerHTML = `
      <div class="ct-mobile-search-suggestions" hidden>
        <div class="ct-mobile-search-suggestions__title">Suggerimenti</div>
        <ul class="ct-mobile-search-suggestions__list"></ul>
      </div>

      <div class="ct-mobile-search-rail__top">
        <div class="ct-mobile-search-rail__heading">Prodotti più venduti</div>
        <div class="ct-mobile-search-rail__nav">
          <button type="button" class="ct-mobile-search-rail__prev" aria-label="Precedente">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M15 6l-6 6 6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
          <button type="button" class="ct-mobile-search-rail__next" aria-label="Successivo">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M9 6l6 6-6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      </div>

      <div class="ct-mobile-search-rail__body"></div>
    `;
    return rail;
  }

  hideRail(instance) {
    if (!instance || !instance.rail) return;

    const suggestionsWrap = instance.rail.querySelector('.ct-mobile-search-suggestions');
    const suggestionsList = instance.rail.querySelector('.ct-mobile-search-suggestions__list');
    const body = instance.rail.querySelector('.ct-mobile-search-rail__body');

    if (instance.refreshTimer) {
      window.clearTimeout(instance.refreshTimer);
      instance.refreshTimer = null;
    }

    if (suggestionsWrap) suggestionsWrap.hidden = true;
    if (suggestionsList) suggestionsList.innerHTML = '';
    if (body) body.innerHTML = '';

    instance.rail.hidden = true;
    instance.lastProductsRenderKey = '';
    instance.lastSuggestionsRenderKey = '';
  }

  showRail(instance) {
    if (!instance || !instance.rail) return;
    instance.rail.hidden = false;
  }

  escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  getResultsSource(instance) {
    return (
      instance.predictiveRoot.querySelector('[data-predictive-search-results]') ||
      instance.predictiveRoot.querySelector('#predictive-search-results') ||
      instance.predictiveRoot
    );
  }

  getHeadingText(instance, hasQuery) {
    if (!hasQuery) return 'Prodotti più venduti';

    const source = this.getResultsSource(instance);
    if (!source) return 'Prodotti';

    const heading =
      source.querySelector('#predictive-search-products') ||
      source.querySelector('[id*="predictive-search-products"]');

    const text = heading ? (heading.textContent || '').trim() : '';
    return text || 'Prodotti';
  }

  extractSuggestions(instance) {
    const source = this.getResultsSource(instance);
    if (!source) return [];

    const selectors = [
      '#predictive-search-results-queries-list',
      '[id*="predictive-search-results-queries-list"]',
      '#predictive-search-results-collections-list',
      '[id*="predictive-search-results-collections-list"]'
    ];

    const rawNodes = [];

    selectors.forEach((selector) => {
      source.querySelectorAll(selector).forEach((list) => {
        rawNodes.push(...list.querySelectorAll(':scope > li a, :scope > li button'));
      });
    });

    const seen = new Set();
    const items = [];

    rawNodes.forEach((node) => {
      const label = (node.textContent || '').trim().replace(/\s+/g, ' ');
      if (!label) return;

      const href = node.tagName.toLowerCase() === 'a' ? node.getAttribute('href') || '' : '';
      const type = href ? 'link' : 'button';
      const key = `${type}|${href}|${label}`;

      if (seen.has(key)) return;
      seen.add(key);

      items.push({
        type,
        href,
        label
      });
    });

    return items.slice(0, 8);
  }

  extractPredictiveProducts(instance) {
  const source = this.getResultsSource(instance);
  if (!source) return [];

  const productList =
    source.querySelector('#predictive-search-results-products-list') ||
    source.querySelector('[id*="predictive-search-results-products-list"]') ||
    null;

  if (!productList) return [];

  const cleanText = (node) => {
    return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  };

  const parseMoneyValue = (text) => {
    if (!text) return null;

    const cleaned = String(text)
      .replace(/\u00A0/g, '')
      .replace(/\s+/g, '')
      .replace(/[^\d,.-]/g, '');

    if (!cleaned) return null;

    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');

    let normalised = cleaned;

    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        normalised = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalised = cleaned.replace(/,/g, '');
      }
    } else if (hasComma) {
      normalised = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      normalised = cleaned.replace(/,/g, '');
    }

    const value = parseFloat(normalised);
    return Number.isFinite(value) ? value : null;
  };

  return Array.from(productList.querySelectorAll(':scope > li'))
    .map((li) => {
      const link = li.querySelector('a');
      if (!link) return null;

      const href = link.getAttribute('href') || '#';
      const img = link.querySelector('img');

      const titleNode =
        link.querySelector('.predictive-search__item-heading') ||
        link.querySelector('.h5') ||
        link.querySelector('span');

      const vendorNode = link.querySelector('.predictive-search__item-vendor');

      let image = '';
      if (img) {
        image = img.getAttribute('src') || img.getAttribute('data-src') || '';
        image = image
          .replace(/([?&])width=\d+/g, '$1width=700')
          .replace(/width:\d+/g, 'width:700');
      }

      const priceWrapper = link.querySelector('.price');
      const isOnSale = priceWrapper && priceWrapper.classList.contains('price--on-sale');

      const regularNode = link.querySelector('.price__regular .price-item--regular');
      const saleNode = link.querySelector('.price__sale .price-item--sale');
      const compareNode = link.querySelector('.price__sale s.price-item--regular, .price__sale s');

      const regularText = cleanText(regularNode);
      const saleText = cleanText(saleNode);
      const compareText = cleanText(compareNode);

      let priceText = regularText;
      let compareAtPriceText = '';

      if (isOnSale) {
        const saleValue = parseMoneyValue(saleText);
        const compareValue = parseMoneyValue(compareText);

        if (saleText) {
          priceText = saleText;
        }

        if (
          compareText &&
          compareValue !== null &&
          saleValue !== null &&
          compareValue > saleValue
        ) {
          compareAtPriceText = compareText;
        }
      }

      return {
        url: href,
        title: titleNode ? (titleNode.textContent || '').trim() : '',
        vendor: vendorNode ? (vendorNode.textContent || '').trim() : '',
        image,
        price: priceText,
        compare_at_price: compareAtPriceText
      };
    })
    .filter(Boolean)
    .slice(0, 10);
}

  makeSuggestionsRenderKey(items) {
    return items.map((item) => `${item.type}|${item.href || ''}|${item.label || ''}`).join('||');
  }

  makeProductsRenderKey(query, heading, products) {
    const ids = products
      .map((product) => `${product.url || ''}|${product.title || ''}|${product.price || ''}|${product.compare_at_price || ''}`)
      .join('||');

    return `${query}::${heading}::${ids}`;
  }

  renderSuggestions(instance, items) {
    const wrap = instance.rail.querySelector('.ct-mobile-search-suggestions');
    const list = instance.rail.querySelector('.ct-mobile-search-suggestions__list');

    if (!wrap || !list) return;

    const renderKey = this.makeSuggestionsRenderKey(items);

    if (instance.lastSuggestionsRenderKey === renderKey) {
      wrap.hidden = items.length === 0;
      return;
    }

    if (!items.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      instance.lastSuggestionsRenderKey = renderKey;
      return;
    }

    list.innerHTML = items
      .map((item) => {
        if (item.type === 'link' && item.href) {
          return `
            <li class="ct-mobile-search-suggestions__item">
              <a class="ct-mobile-search-suggestions__link" href="${item.href}">
                ${this.escapeHtml(item.label)}
              </a>
            </li>
          `;
        }

        return `
          <li class="ct-mobile-search-suggestions__item">
            <button type="button" class="ct-mobile-search-suggestions__button">
              ${this.escapeHtml(item.label)}
            </button>
          </li>
        `;
      })
      .join('');

    list.querySelectorAll('.ct-mobile-search-suggestions__button').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const label = (button.textContent || '').trim();
        instance.input.value = label;
        instance.input.focus();
        instance.input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    wrap.hidden = false;
    instance.lastSuggestionsRenderKey = renderKey;
  }

  renderProducts(instance, products, headingText, query = '') {
    const headingEl = instance.rail.querySelector('.ct-mobile-search-rail__heading');
    const body = instance.rail.querySelector('.ct-mobile-search-rail__body');

    if (!headingEl || !body) return;

    const renderKey = this.makeProductsRenderKey(query, headingText, products);

    if (instance.lastProductsRenderKey === renderKey) {
      this.showRail(instance);
      return;
    }

    headingEl.textContent = headingText || 'Prodotti';

    if (!products.length) {
      body.innerHTML = `<div class="ct-mobile-search-rail__message">Nessun prodotto trovato.</div>`;
      this.bindNav(instance, null);
      this.showRail(instance);
      instance.lastProductsRenderKey = renderKey;
      return;
    }

    const cards = products
      .map((product) => `
        <div class="ct-mobile-search-rail__card">
          <a href="${product.url || '#'}">
            ${product.image ? `<img src="${product.image}" alt="${this.escapeHtml(product.title || '')}">` : ''}
            ${product.vendor ? `<div class="ct-mobile-search-rail__vendor">${this.escapeHtml(product.vendor)}</div>` : ''}
            <div class="ct-mobile-search-rail__title">${this.escapeHtml(product.title || '')}</div>
            <div class="ct-mobile-search-rail__price">
              ${product.compare_at_price ? `<span class="ct-mobile-search-rail__price-compare">${this.escapeHtml(product.compare_at_price)}</span>` : ''}
              ${product.price ? `<span class="ct-mobile-search-rail__price-current">${this.escapeHtml(product.price)}</span>` : ''}
            </div>
          </a>
        </div>
      `)
      .join('');

    body.innerHTML = `<div class="ct-mobile-search-rail__track">${cards}</div>`;

    const track = body.querySelector('.ct-mobile-search-rail__track');
    this.bindNav(instance, track);
    this.showRail(instance);
    instance.lastProductsRenderKey = renderKey;
  }

  bindNav(instance, track) {
    const prevBtn = instance.rail.querySelector('.ct-mobile-search-rail__prev');
    const nextBtn = instance.rail.querySelector('.ct-mobile-search-rail__next');

    if (!prevBtn || !nextBtn) return;

    prevBtn.replaceWith(prevBtn.cloneNode(true));
    nextBtn.replaceWith(nextBtn.cloneNode(true));

    const newPrevBtn = instance.rail.querySelector('.ct-mobile-search-rail__prev');
    const newNextBtn = instance.rail.querySelector('.ct-mobile-search-rail__next');

    if (!track) {
      newPrevBtn.disabled = true;
      newNextBtn.disabled = true;
      return;
    }

    const scrollAmount = () => {
      const firstCard = track.querySelector('.ct-mobile-search-rail__card');
      if (!firstCard) return Math.round(track.clientWidth * 0.5);

      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.gap || 0) || 0;
      return Math.round(firstCard.getBoundingClientRect().width + gap);
    };

    const updateState = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      newPrevBtn.disabled = track.scrollLeft <= 4;
      newNextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    };

    newPrevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    newNextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateState, { passive: true });
    requestAnimationFrame(updateState);
  }

  refresh(instance) {
    const query = (instance.input.value || '').trim();
    const isLoading = instance.predictiveRoot.classList.contains('predictive-search--loading');

    if (!query) {
      this.renderSuggestions(instance, []);
      this.renderProducts(instance, this.bestSellerProducts, 'Prodotti più venduti', '');
      return;
    }

    if (query.length < this.minQueryLength) {
      this.renderSuggestions(instance, []);
      this.renderProducts(instance, [], 'Prodotti', query);
      return;
    }

    if (isLoading) return;

    const suggestions = this.extractSuggestions(instance);
    const products = this.extractPredictiveProducts(instance);
    const heading = this.getHeadingText(instance, true);

    this.renderSuggestions(instance, suggestions);
    this.renderProducts(instance, products, heading, query);
  }
}

  new DesktopHeaderController();
  new DesktopPredictiveOverlay();
  new MobilePredictiveEnhancer();

  ctTagBottomBarMenuItems();
  ctSetMobileAnnouncementHeight();

  window.addEventListener('resize', ctSetMobileAnnouncementHeight, { passive: true });
  window.addEventListener('scroll', ctSetMobileAnnouncementHeight, { passive: true });
  window.addEventListener('load', ctSetMobileAnnouncementHeight);

  document.addEventListener('shopify:section:load', () => {
    ctTagBottomBarMenuItems();
    ctSetMobileAnnouncementHeight();
  });

  document.addEventListener('DOMContentLoaded', () => {
    ctTagBottomBarMenuItems();
    ctSetMobileAnnouncementHeight();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
